import {types, flow, getRoot} from 'mobx-state-tree';
import moment from 'moment';
import * as api from '../lib/api';

const Transaction = types
  .model('Transaction', {
    id: types.identifier,
    from: types.string,
    fromEmail: types.optional(types.string, ''),
    toEmail: types.optional(types.string, ''),
    to: types.string,
    amount: types.number,
    status: types.string,
    createdAt: types.string,
    updatedAt: types.string
  })
  .views((self) => ({
    get income() {
      return self.to.toLowerCase() === getRoot(self).user.address.toLowerCase();
    },
    get amountFormatted() {
      return (self.amount / 100).toFixed(2);
    },
    get dateFormatted() {
      return moment(self.updatedAt).format('D MMMM, YYYY');
    },
    get email() {
      return self.income ? self.fromEmail : self.toEmail;
    }
  }));

const Transactions = types
  .model('Transactions', {
    items: types.array(Transaction),
    transferring: false,
    loading: false
  })
  .actions((self) => {
    const fetch = flow(function* (loading = true) {
      self.loading = loading;
      try {
        self.items = yield api.fetchTransactions();
        self.loading = false;
      } catch (error) {
        self.loading = false;
        console.error(error);
      }
    });
    const startPolling = function (interval = 1000) {
      self.interval = setInterval(() => self.fetch(false), interval);
    };

    const stopPolling = function () {
      if (self.interval) clearInterval(self.interval);
    };

    const transfer = flow(function* ({address, amount}) {
      self.transferring = true;
      try {
        const trx = yield api.transfer({
          address,
          amount: amount * 100
        });
        self.items.unshift(trx);
        self.transferring = false;
      } catch (error) {
        self.transferring = false;
        throw error;
      }
    });
    return {fetch, transfer, startPolling, stopPolling};
  });

export default Transactions;
